import classroom from "./classroom";

export default { ...classroom };
